import { createSlice } from "@reduxjs/toolkit";

const createReportSlice = createSlice({
    name: "createReport",
    initialState: {
        bankAccounts: null,
        bankAccountsError: null,
        bankAccountsLoading: false,
        isAnalyzing: false,
        isEdit: false,
        uploadedFiles: [],
        bankOptions: [],
        createReportData: null,
        createReportLoading: false,
        createReportError: null,
        reportAnalysisProgress:null,
        reportAnalysisProgressLoading:false,
        reportAnalysisProgressError:null,
        reportAnaylysisStatus: null
    },
    reducers: {
        setBankAccountDetails: (state, { payload }) => {
            state.bankAccounts = payload;
        },
        setBankAccountError: (state, { payload }) => {
            state.bankAccountsError = payload;
        },
        setBankAccountLoading: (state, { payload }) => {
            state.bankAccountsLoading = payload;
        },
        setIsAnalyzing: (state, { payload }) => {
            state.isAnalyzing = payload;
        },
        setIsEdit: (state, { payload }) => {
            state.isEdit = payload;
        },
        setUploadedFiles: (state, { payload }) => {
            state.uploadedFiles = payload;
        },
        setBankOptions: (state, { payload }) => {
            state.bankOptions = payload;
        },
        setCreateReportData: (state, { payload }) => {
            state.createReportData = payload;
        },
        setCreateReportLoading: (state, { payload }) => {
            state.createReportLoading = payload;
        },
        setCreateReportError: (state, { payload }) => {
            state.createReportError = payload;
        },
        setReportAnalysisProgress: (state, { payload }) => {
            state.reportAnalysisProgress = payload;
        },
        setReportAnalysisProgressLoading: (state, { payload }) => {
            state.reportAnalysisProgressLoading = payload;
        },
        setReportAnalysisProgressError: (state, { payload }) => {
            state.reportAnalysisProgressError = payload;
        },
        setReportAnalysisStatus: (state, { payload }) => {
            state.reportAnaylysisStatus = payload;
        }
    }
});

export const { setBankAccountDetails, setBankAccountError, setBankAccountLoading, setIsAnalyzing, setIsEdit, setUploadedFiles, setBankOptions, setCreateReportData, setCreateReportLoading, setCreateReportError, setReportAnalysisProgress, setReportAnalysisProgressError, setReportAnalysisProgressLoading, setReportAnalysisStatus } = createReportSlice.actions;

export default createReportSlice.reducer;